import React from 'react';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { WhyThisWorks } from '../components/WhyThisWorks';
import { ProofSection } from '../components/ProofSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
interface LandingPageProps {
  onNavigate: (page: 'landing' | 'projects') => void;
}
export function LandingPage({
  onNavigate
}: LandingPageProps) {
  return <main className="min-h-screen w-full bg-white selection:bg-neutral-900 selection:text-white" data-id="element-97">
      <Navbar onNavigate={onNavigate} currentPage="landing" data-id="element-98" />
      <Hero data-id="element-99" />
      <HowItWorks data-id="element-100" />
      <WhyThisWorks data-id="element-101" />
      <ProofSection data-id="element-102" />
      <FinalCTA data-id="element-103" />
      <Footer data-id="element-104" />
    </main>;
}